module.exports = __webpack_public_path__ + "static/media/upload.8a9869b0.svg";